import { Injectable } from '@angular/core';
import { EQimaDotSize } from '@qima/ngx-qima';

@Injectable({
  providedIn: 'root',
})
export class QimaDotService {
  public readonly dotSize = EQimaDotSize;
}
